export default "__VITE_ASSET__Bhumi6JE__"